import axios from './axios'
export default {
  signup: function(data) {
    return axios.post('/register', data)
  },
  login: function(data) {
    return axios.post('/login', data)
  },
  verifyUser: function(token) {
    return axios.get(`/user/verify?token=${token}`)
  },
  getDetails: function() {
    return axios.get(`/${process.env.VUE_APP_API_VERSION}/users/me`)
  },
  logout: function() {
    return axios.post(`/logout`)
  },
  onboardingComplete: function(data) {
    return axios.post(`/onboarding/save`, data)
  },
  getUsers: function() {
    return axios.get(`/${process.env.VUE_APP_API_VERSION}/users`)
  },
  addUser: function(data) {
    return axios.post(`/${process.env.VUE_APP_API_VERSION}/users`, data)
  },
  updateDetails: function(user) {
    return axios.post(
      `/${process.env.VUE_APP_API_VERSION}/users/${user.id}`,
      user
    )
  },
  deleteUser: function(id) {
    return axios.delete(`/${process.env.VUE_APP_API_VERSION}/users/${id}`)
  },
  deleteAccount: function(id, data) {
    return axios.post(`/${process.env.VUE_APP_API_VERSION}/users/${id}/delete-account`, data)
  },
  resetPasswordRequest: function(data) {
    return axios.post('/password-reset', data)
  },
  setPassword: function(data) {
    return axios.post('/set-password', data)
  },
  setAccManagerPassword: function(data) {
    return axios.post('/set-account-manager-password', data)
  },
  changePassword: function(id, data) {
    return axios.post(`/${process.env.VUE_APP_API_VERSION}/users/${id}/change-password`, data)
  },
  demo: function(data) {
    return axios.post('/demo')
  },
  oauthGrantRequest: function(data) {
    return axios.post('/oauth/authorize', data)
  },
  
}
